import React from "react";
import { Button } from "@material-ui/core";

const Intro = () => (
  <div>
    <p style={{ marginTop: "15%", marginLeft: "30%" }}>
      Welcome Dashboard Screen
      <br></br>
      <br></br>
      <Button
        color="secondary"
        variant="outlined"
        onClick={() => {
          localStorage.clear();
          window.location.reload();
        }}
      >
        Logout
      </Button>
    </p>

    <br />
  </div>
);

export default Intro;
